import React, { useState, useEffect } from "react";
import {
  CourseDepartmentSelect,
  CourseLevelSelect,
  CourseApScoreSelect,
  ClassForTranskriptSelect,
} from "../../ui/myselect";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../usercontext";
import { getIdData, addData, updateData } from "../../../lib/courselesson";

export default function GlobalStudentLessonEdit2({
  studentId,
  status,
  studentClass,
}) {
  const [coursename, setCoursename] = useState("");
  const [department, setDepartment] = useState("");
  const [level, setLevel] = useState("");
  const [apscore, setApscore] = useState(0);
  const [grade, setGrade] = useState("");
  const [credit, setCredit] = useState("");
  const [courseyear, setCourseyear] = useState(9);
  const [isgpacalc, setIsgpacalc] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if ((status || "").toLowerCase() === "add") {
      if (!department) setDepartment("English");
      if (!level) setLevel("AP");
    }
  
    if (status !== "Add") {
      loadData();
    }
  }, [status]);
  

  const loadData = async () => {
    const data = await getIdData(status);
    const item = data[0];
    console.log(item);
    setCoursename(item.coursename);
    setDepartment(item.department);
    setLevel(item.level);
    setApscore(item.apscore);
    setGrade(item.grade);
    setCredit(item.credit);
    setCourseyear(item.courseyear);
    setIsgpacalc(item.isgpacalc);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      coursename,
      department,
      level,
      apscore: level === "AP" ? apscore : 0,
      grade,
      credit,
      courseyear,
      isgpacalc,
      studentId,
    };
    
    if (status === "Add") {
      await addData(payload);
    } else {
      await updateData({ ...payload, id: status });
    }
    navigate(-1);
  };

  return (
    <div className="col-12">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-2">
          <h3>{status === "Add" ? "Add New Lesson" : "Update Lesson"}</h3>
          <form onSubmit={handleSubmit} className="checkout-form">
            <div className="form-group">
              <label>Course Name</label>
              <input
                type="text"
                value={coursename}
                onChange={(e) => setCoursename(e.target.value)}
                className="form-control"
                required
              />
            </div>

            <div className="form-group">
              <label>Department</label>
              <CourseDepartmentSelect
                value={department}
                setValue={setDepartment}
              />
            </div>

            <div className="form-group">
              <label>Course Level</label>
              <CourseLevelSelect value={level} setValue={setLevel} />
            </div>

            {level === "AP" && (
              <div className="form-group">
                <label>AP Test Score</label>
                <CourseApScoreSelect value={apscore} setValue={setApscore} />
              </div>
            )}

            <div className="form-group">
              <label>Grade</label>
              <input
                type="number"
                value={grade}
                onChange={(e) => setGrade(Number(e.target.value))}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Credit</label>
              <input
                type="number"
                step="any"
                value={credit}
                onChange={(e) => setCredit(parseFloat(e.target.value))}
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>GPA Calculation</label>
              <div>
                <label>
                  <input
                    type="radio"
                    checked={isgpacalc}
                    onChange={() => setIsgpacalc(true)}
                  />
                  Yes
                </label>
                <label className="ms-3">
                  <input
                    type="radio"
                    checked={!isgpacalc}
                    onChange={() => setIsgpacalc(false)}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="form-group">
              <label>High School Year</label>
              <ClassForTranskriptSelect
                value={courseyear}
                setValue={setCourseyear}
              />
            </div>

            <div className="d-flex justify-content-between">
              <button type="submit" className="btn btn-primary">
                {status === "Add" ? "Add" : "Update"}
              </button>
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
